import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { useField } from '@unform/core';
import { useEffect } from 'react';

interface IDadosSelect {
  nameBD: number;    // agora É number mesmo
  descricao: string;
}

interface BasicSelectProps {
  data: IDadosSelect[];
  label: string;
  name: string;
  disabled?: boolean;
  aoClicar?: (novoValor: number | undefined) => void;
}

export const BasicSelectNumber: React.FC<BasicSelectProps> = (props) => {
  const { fieldName, registerField, error, clearError } = useField(props.name);

  // valor REAL usado pelo Unform
  const [value, setValue] = React.useState<number | undefined>(undefined);

  // valor convertido para string para o Select
  const valueString = value !== undefined ? String(value) : '';

  const handleChange = (event: SelectChangeEvent) => {
    clearError();

    const newNumber = Number(event.target.value);

    setValue(newNumber);

    props.aoClicar?.(newNumber);
  };

  useEffect(() => {
    registerField({
      name: fieldName,
      getValue: () => value,
      setValue: (_, newValue) => setValue(newValue ?? undefined),
      clearValue: () => setValue(undefined)
    });
  }, [registerField, fieldName, value]);

  return (
    <Box>
      <FormControl fullWidth error={!!error}>
        <InputLabel>{props.label}</InputLabel>

        <Select
          size="small"
          fullWidth
          value={valueString}       // 👈 Select recebe string SEM ERRO
          label={props.label}
          onChange={handleChange}
          disabled={props.disabled}
        >
          {props.data.map((item) => (
            <MenuItem key={item.nameBD} value={String(item.nameBD)}>
              {item.descricao}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {error && (
        <div style={{ fontSize: 14, color: '#D32F2F' }}>
          {error}
        </div>
      )}
    </Box>
  );
};
